// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const HELP_LOCALE_MAP= {
   'de': 'de-de',
   'es': 'es-es',
   'es-41': 'es-es',
   'fi': 'fi-fi',
   'it': 'it-it',
   'ar': 'ar-ar',
   'jp': 'ja'
   
}

type CustomLink = {
  type: string;
  href: string;
  label: string;
}
class LinksController {
   $scope: any
   config: any
   scopeLinks: any
   constructor($scope: any, config: any, $locale: any, $templateCache: any, embeddedValues: any, $attrs: any) {
      this.$scope = $scope
      this.config = config
      this.$scope.embeddedValues = embeddedValues

      this.$scope.behaviorClass = {}
      this.$scope.behaviorClass.btn = !!$attrs.asBtn
      this.$scope.behaviorClass['btn-link'] = !$attrs.asBtn
      
      const customLinksList = this.config.data.customLinks.customLinksList || []
      const headerCustomLinks: CustomLink[] = []
      const menuCustomLinks: CustomLink[] = []

      customLinksList.forEach((customLink: any) => {
         if (!customLink.disabled && customLink.url && customLink.label) {
            if (String(customLink['in-header']).toLowerCase() === 'true') {
               headerCustomLinks.push({
                  type: 'custom',
                  href: customLink.url,
                  label: customLink.label
               })
            }
            if (String(customLink['in-menu']).toLowerCase() === 'true') {
               menuCustomLinks.push({
                  type: 'custom',
                  href: customLink.url,
                  label: customLink.label
               })
            }
         }
      })

      this.scopeLinks = (this.$scope.links = {
         links: [],
         headerCustomLinks,
         menuCustomLinks,
         flow: this.config.data.flow.enabled,
         localizedHelpTemplate: `/assets/help/help_${$locale.id}.html`
      })

      // default to english help if localized help template does NOT exist
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      if (!$templateCache.get(this.scopeLinks.localizedHelpTemplate) && !(HELP_LOCALE_MAP[$locale.id] == null)) { this.scopeLinks.localizedHelpTemplate = `/assets/help/help_${HELP_LOCALE_MAP[$locale.id]}.html` }
      if (!$templateCache.get(this.scopeLinks.localizedHelpTemplate)) { this.scopeLinks.localizedHelpTemplate = "/assets/help/help_en-us.html" }
      const linkDialogs = ['feedback', 'help']
      for (var key in this.config.data.links) {
         var link
         var val = this.config.data.links[key]
         if (key === 'feedback') {
            // Refworks login link when flow is enabled and before feedback
            if (this.scopeLinks.flow) {
               link = {type: 'flow'}
               this.scopeLinks.headerCustomLinks.push(link)
            }
         }

         if (val.href !== '#') {
            link = {
               type: key,
               href: val.href,
               label: val.label
            }
            // @ts-expect-error TS(2339) FIXME: Property 'click' does not exist on type '{ type: s... Remove this comment to see the full error message
            if (linkDialogs.includes(key)) { link.click = this.$scope.displayDialog }
            // @ts-expect-error TS(2339) FIXME: Property 'image' does not exist on type '{ type: s... Remove this comment to see the full error message
            if (val.image) { link.image = val.image }
            // @ts-expect-error TS(2339) FIXME: Property 'click' does not exist on type '{ type: s... Remove this comment to see the full error message
            if ((link.href && link.label) || (link.click && link.label)) {
               this.scopeLinks.headerCustomLinks.push(link)
               this.scopeLinks.menuCustomLinks.push(link)
            }
         }
      }
   }
}

LinksController.$inject = ['$scope', 'configService', '$locale', '$templateCache', 'embeddedWidgetValues', '$attrs']

angular.module('summonApp.controllers')
   .controller('LinksCtrl', LinksController)
